import api from "../api/axios";

export const getSubscriptions = async () => {
    const res = await api.get("/subscriptions");
    return res.data;
};

export const getSubscription = async (id) => {
    const res = await api.get(`/subscriptions/${id}`);
    return res.data;
};

export const createSubscription = async (data) => {
    const res = await api.post("/subscriptions", data);
    return res.data;
};

export const updateSubscription = async (id, data) => {
    const res = await api.put(`/subscriptions/${id}`, data);
    return res.data;
};

export const deleteSubscription = async (id) => {
    const res = await api.delete(`/subscriptions/${id}`);
    return res.data;
};

/** PDF basé sur le dernier paiement lié à l’abonnement (GET /api/subscriptions/:id/invoice) */
export const downloadSubscriptionInvoice = async (subscriptionId) => {
    const res = await api.get(`/subscriptions/${subscriptionId}/invoice`, { responseType: "blob" });
    const blob = new Blob([res.data], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `releve-abonnement-${subscriptionId}.pdf`;
    a.click();
    window.URL.revokeObjectURL(url);
};